import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditEvent: FC = () => {
  const intl = useIntl()

  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10; // Per page show the data pagination
  const Pagesize = 10;
  const red = "red";
  const [totalItems, setTotalItems] = useState(0);
  const [categories, setCategories] = useState([]);
  const [totalpages, settotalPages] = useState(0);
  const [eventList, setEventList] = useState([]);
  const [eventInfo, setEventInfo] = useState<any>([]);
  const siteId = '2';

  let history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const eventId = queryParams.get('eventId');

  const [companyList, setCompanyList] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [ckeventInfo, setckEventInfo] = useState<any>('');
  const [eventDate, setEventDate] = useState(new Date());
  const [eventtypeslist, setEventTypes] = useState([]);
  const [query, setQuery] = useState("");
  const [sourceCompanyId, setSourceCompanyId] = useState("");
  const [eventcompany, setEventcompanyid] = useState("");
  //const eventId = '5';
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });
  function handleChangeEventDesc(content) {
    setckEventInfo(content);
  }
  function getIndustries() {

    services.getIndustryData().then((res) => {
      //console.log(JSON.stringify(res)); 

      if (res.data) {
        setCategories(res.data.content);
      }
    });
  }


  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {       
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size              
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function getEventTypesList() {

    services.adminGetEventTypesList().then((res) => {
      console.log("#######################");
      console.log(JSON.stringify(res));
      //alert("314")
      if (res.data) {
        console.log(JSON.stringify(res));

        setEventTypes(res.data);
      }


    });
  }

  const animatedComponents = makeAnimated();
  const loadOptionsSource = (inputValue, callback) => {
    // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var pageSize = '1000';
    var pageNumber = '1';
    var siteId = '2'
    var endpoint = process.env.REACT_APP_AWS_API + `adminGetCompanyList?siteId=` + siteId + `&status=` + statuschk + `&pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&sortBy=` + sortBy + `&sortDir=` + sortDir + `&title=&searchTxt=${query}`;

    fetch(endpoint).then(response => {
      response.json().then(data => {
        //console.log("202-->"+JSON.stringify(data));
        const results = data.content;
        //console.log(data.content);
        callback(results);
      });
    });

  };

  const loadOptionsSource_default = (inputValue, callback) => {
    var defaultendpoint = process.env.REACT_APP_AWS_API + `/adminGetCompanyProfile?companyId=` + eventcompany;

    fetch(defaultendpoint).then(response => {
      response.json().then(data => {
        //console.log("202-->"+JSON.stringify(data));
        const results = data.content;
        //console.log(data.content);
        callback(results);
      });
    });

    services.adminGetCompanyProfile(eventcompany).then((res) => {
      if (res.data) {
      }
    });

  };



  const handleChangecompany = (selectedOption) => {
    console.log(selectedOption);
  }

  function getAdminProfilesList() {
    var searchTxt = "";//$('#search_input').val();
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var itemsPerPage = '15000';
    var pageNumberV = '1';
    var siteIdv = '2'
    //alert("309")
    services.adminGetCompanyList(siteIdv, itemsPerPage, pageNumberV, searchTxt, statuschk, sortBy, sortDir).then((res) => {

      if (res.data) {
        // console.log(JSON.stringify(res));

        setCompanyList(res.data.content);
      }


    });
  }

  function triggerdateclick() {
    $('#eventdatesel').click();
  }

  function getCompanyInfo(companyId) {
    services.adminGetCompanyProfile(companyId).then((res) => {
      if (res.data) {

        setTimeout(() => {
          setSourceCompanyId(res.data);

        }, 1500)




      }

    });
  };


  function getEventById(eventIdGet) {

    services.getEventById(eventIdGet).then((res) => {
      console.log("#######################");

      if (res.data) {
        var event_info = res.data;
        console.log(event_info);

        $('#event_title').val(event_info.eventTitle);

        var dtget = moment(event_info.eventDate).format("YYYY-MM-DD");
        var dt = new Date(dtget);
        setEventDate(dt);
        //var companyid = event_info.companyId;
        $('#event_company').val(event_info.companyId);
        setEventcompanyid(event_info.companyId);
        //loadOptionsSource_default();

        $('#event_company option[value=' + event_info.companyId + ']').prop('selected', 'selected');
        $('#event_company option[value=' + event_info.companyId + ']').attr('selected', 'selected');

        $('#eventdatesel').val(event_info.eventDate);
        $('#event_address').val(event_info.eventAddress);
        $('#event_city').val(event_info.eventCity);
        $('#event_state').val(event_info.eventState);
        $('#event_state1').val(141);
        $('#postalcode').val(event_info.eventZip);
        $('#event_link').val(event_info.eventExternalLink);
        $('#event_type').val(event_info.eventTypeId);
        $('#showon').val(event_info.showEventInCalendar);
        $('#showon option[value=' + event_info.showEventInCalendar + ']').prop('selected', true);
        $('#showon option[value=' + event_info.showEventInCalendar + ']').attr('selected', "true");
        //var compid = event_info.companyId;
        // $('#event_company option[value='+ compid +']').attr('selected', 'selected');
        // $('#event_company option[value='+ compid +']').prop('selected', 'selected');

        setTimeout(() => {
          /*
                          var companyid = event_info.companyId;
                          $('#event_company').val(companyid); 
                          $('#event_company option[value='+ companyid +']').prop('selected', 'selected');
          */
          var industryvals = event_info.eventIndustry;
          for (var i = 0; i < industryvals.length; i++) {
            // $('#seeking_chks '+seekingtypes[j]).attr('checked', 'checked');
            $('input[name="categoryindustry"][value="' + industryvals[i] + '"]').prop('checked', true);
            $('input[name="categoryindustry"][value="' + industryvals[i] + '"]').attr('checked', "true");
          }

          if (industryvals.length >= 3) {
            $('input[name="categoryindustry"]').not(':checked').prop('disabled', true);
          } else {
            $('input[name="categoryindustry"]').prop('disabled', false);
          }



        }, 1000);

        setEventInfo(res.data);
      }
    });
  }

  const submitValue = () => {
    var categoriesArray = [];

    $.each($("input[name='categoryindustry']:checked"), function () {
      categoriesArray.push($(this).val());
    });

    var validateEditorTxt = 1;
    if ($('#event_title').val() == "") {
      $("#eventtitleValidMsg").show();
      $(window).scrollTop($('#eventtitleValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventtitleValidMsg").hide();
    }

    if ($('#eventdatesel').val() == "") {
      $("#eventdateValidMsg").show();
      $(window).scrollTop($('#eventdateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventdateValidMsg").hide();
    }


    if (ckeventInfo == "") {
      $("#eventInfoValidMsg").show();
      $(window).scrollTop($('#eventInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventInfoValidMsg").hide();
    }
    if (validateEditorTxt == 0) {
      return false;
    }

    const requestObject = {
      "eventId": eventId,
      "siteId": "2",
      "companyId": $('#event_company').val(),
      "companyName": "",
      "eventTitle": $('#event_title').val(),
      "eventDate": eventDate,
      "eventAddress": $('#event_address').val(),
      "eventCity": $('#event_city').val(),
      "eventState": $('#event_state').val(),
      "eventZip": $('#postalcode').val(),
      "eventDescription": ckeventInfo,
      "eventExternalLink": $('#event_link').val(),
      "eventTypeId": $('#event_type').val(),
      "eventStatus": "published",
      "showEventInCalendar": $('#showon').val(),
      "eventIndustry": categoriesArray
    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.admineditEvent(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#editeventsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editeventsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/eventlist');
        }, 1000);
      }
      else {
        $("#editeventfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#editeventfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);
      }



    });
  }
  function validateCheck() {
    const checked = $('input[name="categoryindustry"]:checked').length;
    //alert(checked);
    if (checked >= 3) {
      $('input[name="categoryindustry"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="categoryindustry"]').prop('disabled', false);
    }
  }

  useEffect(() => {


    getIndustries();
    setTimeout(() => {
      getAdminProfilesList();
    }, 1000);

    getEventTypesList();
    //console.log(sourceCompanyId);
    $("#eventInfoValidMsg").hide();
    $(".se-dialog-tabs").hide();
    $('#eventtitleValidMsg').hide();
    $('#eventdateValidMsg').hide();
    $('#editeventsuccessMessage').hide();
    $('#editeventfailMessage').hide();
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
    getEventById(eventId);
  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Edit Event' })}</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>

        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className="form-label"><strong>Event Sponsored By:</strong>  {eventInfo.companyName}</label>
                </div>

                {/* <AsyncSelect
                    cacheOptions
                    components={animatedComponents}                  
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.companyId}
                    value={loadOptionsSource_default}
                    loadOptions={loadOptionsSource}
                    onInputChange={(value) => setQuery(value)}
                    onChange={handleChangecompany}
                    onChange={(value) => setSourceCompanyId(value)}
                /> */}


                {/*<select className="form-select" id="event_company" name="event_company" aria-label="Select example">
                  <option value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId}>{data.name}</option>
                    ))}
                </select> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Event Title</label>

                </div>

                <input type="text" id="event_title" name="event_title" className="form-control" placeholder="" />
                <div id="eventtitleValidMsg" style={{ color: red }} className="error">Event Title is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10 position-relative">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Date</label>

                </div>
                <div>

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={eventDate}
                    onChange={(date) => setEventDate(date)}
                    minDate={moment().toDate()}
                    id="eventdatesel" name="eventdatesel"
                  />
                  <div onClick={triggerdateclick} style={{ position: "absolute", right: "10px", top: "36px" }}>
                    <KTSVG path='/media/icons/duotune/art/date-icon.svg' />
                  </div>
                </div>
                {/*  <input type="text" id="event_date" name="event_date" className="form-control" placeholder=""   /> */}
                <div id="eventdateValidMsg" style={{ color: red }} className="error">Date is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Type</label>

                </div>
                <select className="form-select" id="event_type" name="event_type" aria-label="Select example">
                  <option selected value="" >Select Type</option>
                  {
                    eventtypeslist.map((data1, index) => (
                      <option value={data1.eventTypeId} >{data1.eventTypeName}</option>
                    ))}
                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="form-label">Address</label>

                </div>
                <input type="text" id="event_address" name="event_address" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">City</label>

                </div>
                <input type="text" id="event_city" name="event_city" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">State</label>

                </div>
                <select className="form-select" id="event_state" name="event_state" aria-label="Select example">
                  <option value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option value={state.stateName}>{state.stateName}</option>
                    ))
                  }
                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Information</label>
                </div>
                {/* <h1>this is FCK editor area</h1> */}

                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="eventInfoId"    
                            data = {eventInfo.eventDescription}                    
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setckEventInfo(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeEventDesc}
                  setContents={eventInfo.eventDescription}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />


                <div id="eventInfoValidMsg" style={{ color: red }} className="error">Information is required.</div>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">More Information link</label>
                  <small className="mb-3">http://example.com</small>
                </div>
                <input type="text" id="event_link" name="event_link" className="form-control" placeholder="" />
              </div>
            </div>



            <div className="col-lg-6 d-none">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Show on Calendar page</label>
                </div>
                <select className="form-select" id="showon" name="showon" aria-label="Select example">

                  <option value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-4">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Industry</label>

                  <div className="row mt-8">



                    {
                      categories.map((data, index) => (
                        <div className="col-md-6 mb-4">
                          <div className="form-check form-check-custom form-check-solid">
                            <input className="form-check-input" type="checkbox" name="categoryindustry" value={data.catId} onClick={() => validateCheck()} />
                            <label className="form-check-label" htmlFor={data.catId}>
                              {data.name}
                            </label>
                          </div>
                        </div>
                      ))}


                    <div className="divider"></div>

                    <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}> Update Event </button>



                  </div>
                </div>
                <div id="editeventsuccessMessage" className="alert alert-success" role="alert">Event Updated Successfully</div>

                <div id="editeventfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
            </div>

          </div>
        </div>
      </form>
    </>
  )
}
export { EditEvent }